module.exports = __webpack_public_path__ + "img/3x.025d31f.jpg";